'use strict';
//open -a Google\ Chrome --args --disable-web-security
angular.module('facebook')
.factory('musicSaScraperService', function (tsSettings, $http, $window, $q) {
    "ngInject";

    var events = [];
    var fb_events = [];
    var event_ids = {};
    var id = 0;
    var accessToken = null;
    var event_pictures = {};

    var parseArtists = function(response) {
        var tmp = document.implementation.createHTMLDocument();
        tmp.body.innerHTML = response.data;

        var items = $(tmp.body.children).find('.dfx-endorsements-archive');
        for (var i = 0; i < items.length; i++) {
            var artist = items[i];
        }
    };

    var getArtists = function () {
            var request = {
                    method: 'GET',
                    url: 'http://www.musicsa.com.au/directory-type/artist/',
                    headers: {
                        'Access-Control-Allow-Origin': 'http://localhost',
                        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
                        'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
                        'Access-Control-Allow-Credentials': 'true'
                    }
                };        
            return $http(request).then(parseArtists);
    };


    return {
        getArtists: getArtists
    };

});
